/* tslint:disable:react-a11y-anchors */
import * as React from 'react'
import { Radio, RadioGroup } from 'react-radio-group'

import { logError } from '../../../../../common/utils/errors'
import BasicForm from '../../basicForm'

interface IProps {
  dismissModalMessage: any
  onCreateNewCollectionFormSubmit: any
  showModalMessage: any
  modalMessages: any
}

interface IState {
  shouldShowMore: boolean
  collectionIsPublic: 'true' | 'false'
  collectionName: string
}

export default class CreateNewCollectionForm extends React.Component<
  IProps,
  IState
> {
  constructor(props: IProps) {
    super(props)
    this.state = {
      shouldShowMore: false,
      collectionIsPublic: 'false',
      collectionName: ''
    }
    this.onVisibleInputChange = this.onVisibleInputChange.bind(this)
    this.onAddNewCollection = this.onAddNewCollection.bind(this)
    this.onCollectionNameInputChange = this.onCollectionNameInputChange.bind(
      this
    )
    this.showMore = this.showMore.bind(this)
    this.showLess = this.showLess.bind(this)
  }

  public render() {
    const { collectionIsPublic, shouldShowMore, collectionName } = this.state
    const { modalMessages } = this.props
    const fromGroupStyle = {
      margin: '16px 0'
    }
    const radioLabelStyle = {
      margin: '0 16px 8px 0'
    }
    const radioInputStyle = {
      marginRight: '8px'
    }
    const whatsThisLinkStyle = {
      fontSize: '11px'
    }
    const cancelButtonStyle = {
      marginLeft: '16px',
      color: '#bababa'
    }
    const messageStyle = {
      margin: '16px 0',
      background: '#c24242',
      color: '#fff',
      padding: '10px',
      display: 'block',
      lineHeight: '10px',
      borderRadius: '2px'
    }

    return (
      <div className="fds-c-modal__section">
        <div className="">
          <h3 className="fds-c-text-heading -size-s">
            Create a new Collection
          </h3>
          <BasicForm
            method="post"
            action="javascript:void(0);"
            className="fds-c-form -layout-vertical-inline"
            onSubmit={this.onAddNewCollection}
          >
            <div style={fromGroupStyle} className="fds-c-form__group">
              <input
                className="fds-c-form-input -type-string -width-full"
                id="bookmark_form_name"
                name="bookmark_form[name]"
                placeholder="Choose a name that is meaningful and descriptive"
                onClick={this.showMore}
                value={collectionName}
                onChange={this.onCollectionNameInputChange}
                type="text"
              />
            </div>
            {shouldShowMore && (
              <div>
                {modalMessages && (
                  <div style={messageStyle} className="fds-c-form__group">
                    <span className="-size-m -color-mid">
                      {modalMessages.message ||
                        'There was an error creating your collection. Please try again.'}
                    </span>
                  </div>
                )}
                <div style={fromGroupStyle} className="fds-c-form__group">
                  <RadioGroup
                    name="bookmark_form[publically_visible]"
                    selectedValue={collectionIsPublic}
                    onChange={this.onVisibleInputChange}
                  >
                    <label style={radioLabelStyle}>
                      <Radio style={radioInputStyle} value="false" />Keep it
                      private
                    </label>
                    <label style={radioLabelStyle}>
                      <Radio style={radioInputStyle} value="true" />Make it
                      public
                    </label>
                  </RadioGroup>
                </div>
                <div style={fromGroupStyle} className="fds-c-form__group">
                  <a
                    style={whatsThisLinkStyle}
                    className="fds-c-text-link -weight-normal -color-dark -decoration-none"
                    href="https://help.market.envato.com/hc/en-us/articles/202821260"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    What&apos;s this?
                  </a>
                </div>
                <div style={fromGroupStyle} className="fds-c-form__group">
                  <input
                    className="fds-c-button--3d -color-primary"
                    type="submit"
                    value="Add new collection"
                  />
                  <a
                    href="#"
                    style={cancelButtonStyle}
                    className="fds-c-text-link -color-dark -decoration-none fds-u-mt1"
                    onClick={this.showLess}
                  >
                    Cancel
                  </a>
                </div>
              </div>
            )}
          </BasicForm>
        </div>
      </div>
    )
  }

  private onVisibleInputChange(value: any) {
    this.setState({
      collectionIsPublic: value
    })
  }

  private onCollectionNameInputChange(
    event: React.ChangeEvent<HTMLInputElement>
  ) {
    this.setState({
      collectionName: event.target.value
    })
  }

  private showMore() {
    this.setState({
      shouldShowMore: true
    })
  }

  private showLess(event: React.MouseEvent<HTMLAnchorElement>) {
    if (event) {
      event.preventDefault()
    }
    // clean up modal messages when toggle the form section
    const { dismissModalMessage } = this.props
    dismissModalMessage()
    this.setState({
      shouldShowMore: false,
      collectionName: ''
    })
  }

  private onAddNewCollection(event: React.FormEvent<HTMLFormElement>) {
    const { collectionIsPublic, collectionName } = this.state
    const { onCreateNewCollectionFormSubmit, showModalMessage } = this.props
    event.preventDefault()

    if (!collectionName || collectionName === '') {
      showModalMessage({
        type: 'error',
        message: 'You need to name your collection.'
      })
    } else {
      onCreateNewCollectionFormSubmit(collectionName, collectionIsPublic)
        .then((action: any) => {
          if (action && action.type === 'addBookmarkSuccess') {
            this.setState({
              collectionName: '',
              shouldShowMore: false
            })
          }
        })
        .catch(logError)
    }
  }
}
